export const customViewConfig = {
  view: {
    infiniteScroll: {
      active: true,
    },
  },
};
